
export default function Coming() {
    return (
        <div className="text-center comeDiv">
            <h2 className="comingText my-5 come-style">Comming Soon..</h2>
        </div>
    )
}
